// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"AF-z","smallCardRow":"BF-z","largeCardRow":"CF-z","productSearchRow":"DF-z","curatedRow":"EF-z"};